import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import * as _ from 'lodash-es';
import { JsonObjectFactoryService } from '../../../shared/_services/json-object-factory.service';

@Injectable({
  providedIn: 'root'
})
export class WwniM3ReconService {
  constructor(private jsonObjectFactoryService: JsonObjectFactoryService) {}

  saveWWNIM3Comments(
    baseUrl: string,
    data: any,
    globalService: any,
    filterParams: any
  ): Observable<any> {
    if (!data?.rowData) return of({ callSuccess: '0', errorMessage: 'Row data is required.' });
    const params = _.merge({}, globalService?.globalParams || globalService || {}, filterParams, {
      object_id: data.rowData.object_id,
      leid: data.rowData.LEID,
      cdr_no: data.rowData.CDR_NO,
      bsla_code: data.rowData.BSLA_CODE,
      reporting_curr: data.rowData.CURRENCY_CODE,
      comments: data.rowData.COMMENTS
    });
    return this.jsonObjectFactoryService.saveJSON6(
      `${baseUrl}/saveJsonObject?action_id=699`,
      params,
      globalService,
      filterParams
    );
  }
}
